
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderGrid extends _Ext.GridBase<ECommOrderRow, any> {
        protected getColumnsKey() { return 'ECommerce.Order'; }
        protected getDialogType() { return ECommOrderDialog; }
        protected getIdProperty() { return ECommOrderRow.idProperty; }
        protected getInsertPermission() { return ECommOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderRow.localTextPrefix; }
        protected getService() { return ECommOrderService.baseUrl; } 
        private autoSize;
        private myToolDropdownButton: J.ToolDropdownButton;

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.setOptions({ rowHeight: 30 });
            let combineButtons: J.ToolDropdownButtonItem[] = [
                
                {
                    key: "EComm",
                    title: 'E-Commerce',
                    icon: "fa-shopping-cart",
                    cssClass: "text-black",
                    onClick: e => {
                        if (!this.onViewSubmit()) {
                            return;
                        }
                        var grid = Common.ECommOrderSelectGrid;

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true
                        });
                        pickerDialog.onSuccess = (selectedItems: ECommOrderRow[]) => {
                            let selectedItems2 = selectedItems;
                            for (var i = 0; i < selectedItems2.length; i++) {
                                var order = selectedItems2[i];
                                order.TransId = null;
                                order.NetAmount = order.NetAmount == undefined ? 0 : order.NetAmount;
                                order.GrossAmount = order.GrossAmount == undefined ? 0 : order.GrossAmount;
                                order.ItemDetails = ItemGridHelper.SetSalesOrderGrid(order.ItemDetails, new Date(order.TransDate), 0, 1, 0, 0, 0,0);

                                ECommOrderService.Create({ Entity: order }, () => { }, { async: false });

                                this.refresh();
                            }

                        }
                        pickerDialog.dialogOpen();
                    }
                },
                {
                    key: null,
                    isSeparator: true
                }, {
                    key: "amazon",
                    title: 'Amazon',
                    icon: "fa-amazon",
                    cssClass: "text-black",
                    onClick: e => {
                        if (!this.onViewSubmit()) {
                            return;
                        }
                        var grid = Common.AmazonOrderSelectGrid;
                        var filters: _Ext.SelectGridFilters = {}


                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, GridFilters: filters
                        });
                        pickerDialog.onSuccess = (selectedItems: ECommOrderRow[]) => {
                            let selectedItems2 = selectedItems;
                            for (var i = 0; i < selectedItems2.length; i++) {
                                var order = selectedItems2[i];
                                order.TransId = null;
                                order.NetAmount = order.NetAmount == undefined ? 0 : order.NetAmount;
                                order.GrossAmount = order.GrossAmount == undefined ? 0 : order.GrossAmount;
                                order.ItemDetails = ItemGridHelper.SetSalesOrderGrid(order.ItemDetails, new Date(order.TransDate), 0, 1, 0, 0, 0, 0);

                                ECommOrderService.Create({ Entity: order }, () => { }, { async: false });

                                this.refresh();
                            }

                        }
                        pickerDialog.dialogOpen();
                    }
                }
            ];
            this.myToolDropdownButton = new J.ToolDropdownButton(this.toolbar.element.find(".buttons-outer"), combineButtons, {
                title: "Import",
                icon: "fa-file-import"
            });

        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {            
            var item = this.itemAt(row);
           // OrderItemsEditor.baseitemcheck = item.BaseItemTypeId;
            super.onClick(e, row, cell);            
        }
        protected addButtonClick() {
            
            let now = new Date();

            var voucher = FormatHelper.GetVoucherNo(86);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<ECommOrderRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 86,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString()                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        //protected createToolbarExtensions() {
        //    super.createToolbarExtensions();
        //    this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        //}
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}
